<template>
    <!--    https://www.svgrepo.com/svg/476947/timezone-->
    <svg
        fill="#000000"
        width="20px"
        height="20px"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 434.044 434.044"
        xml:space="preserve"
    >
        <g>
            <path
                d="M245.384,248.172c8.234-7.633,13.4-18.531,13.4-30.617c0-23.028-18.734-41.762-41.762-41.762
		c-23.028,0-41.762,18.734-41.762,41.762c0,12.086,5.166,22.984,13.4,30.617c-16.1,9.669-26.9,27.297-26.9,47.406v41.971
		c0,9.296,5.544,17.322,13.5,20.945v56.76c0,10.361,8.43,18.791,18.791,18.791h45.942c10.361,0,18.791-8.43,18.791-18.791v-56.76
		c7.956-3.623,13.5-11.648,13.5-20.945v-41.971C272.283,275.469,261.484,257.84,245.384,248.172z M217.022,194.792
		c12.551,0,22.762,10.211,22.762,22.762s-10.211,22.762-22.762,22.762c-12.551,0-22.762-10.211-22.762-22.762
		S204.471,194.792,217.022,194.792z M253.283,337.548c0,2.205-1.794,3.999-4,3.999c-5.247,0-9.5,4.253-9.5,9.5v63.996h-13.262
		v-54.932c0-5.247-4.253-9.5-9.5-9.5s-9.5,4.253-9.5,9.5v54.932H194.26v-63.996c0-5.247-4.253-9.5-9.5-9.5c-2.206,0-4-1.794-4-3.999
		v-41.971c0-19.994,16.267-36.261,36.262-36.261s36.261,16.267,36.261,36.261V337.548z"
            />
            <path
                d="M178.445,85.818h14.67v48.23c0,5.247,4.253,9.5,9.5,9.5h28.815c5.247,0,9.5-4.253,9.5-9.5v-48.23h14.67
		c3.394,0,6.53-1.811,8.227-4.75c1.697-2.939,1.697-6.561,0-9.5L225.249,4.75C223.552,1.811,220.416,0,217.022,0
		s-6.53,1.811-8.227,4.75l-38.577,66.818c-1.697,2.939-1.697,6.561,0,9.5C171.914,84.008,175.051,85.818,178.445,85.818z
		 M217.022,28.5l22.123,38.318h-7.715c-5.247,0-9.5,4.253-9.5,9.5v48.23h-9.815v-48.23c0-5.247-4.253-9.5-9.5-9.5h-7.715
		L217.022,28.5z"
            />
            <path
                d="M389.031,71.248c-2.399-2.4-5.896-3.337-9.176-2.459l-74.526,19.969c-3.278,0.878-5.839,3.439-6.717,6.718
		s0.059,6.776,2.459,9.176l10.373,10.373l-34.104,34.104c-1.782,1.781-2.783,4.198-2.783,6.718s1.001,4.936,2.783,6.718
		l20.375,20.375c1.855,1.855,4.286,2.782,6.717,2.782s4.862-0.927,6.717-2.782l34.104-34.104l10.374,10.373
		c2.399,2.399,5.894,3.337,9.176,2.459c3.278-0.878,5.839-3.439,6.717-6.718l19.969-74.526
		C392.368,77.146,391.431,73.648,389.031,71.248z M357.427,134.139l-5.456-5.456c-3.71-3.71-9.725-3.71-13.435,0l-34.104,34.104
		l-6.94-6.94l34.104-34.104c3.71-3.71,3.71-9.725,0-13.435l-5.456-5.456l42.739-11.452L357.427,134.139z"
            />
            <path
                d="M122.601,115.026l10.373-10.373c2.4-2.4,3.337-5.898,2.459-9.176s-3.439-5.839-6.717-6.718L54.189,68.79
		c-3.276-0.878-6.776,0.059-9.176,2.459c-2.4,2.4-3.337,5.898-2.458,9.176l19.969,74.526c0.878,3.278,3.439,5.839,6.717,6.718
		c3.279,0.878,6.776-0.059,9.176-2.459l10.374-10.373l34.104,34.104c1.855,1.855,4.286,2.783,6.718,2.782
		c2.431,0,4.863-0.928,6.717-2.782l20.375-20.375c1.782-1.781,2.783-4.198,2.783-6.718s-1.001-4.936-2.782-6.718L122.601,115.026z
		 M129.612,162.788l-34.104-34.104c-1.782-1.781-4.198-2.782-6.718-2.782s-4.936,1.001-6.717,2.782l-5.456,5.456L65.166,91.401
		l42.739,11.451l-5.456,5.456c-3.71,3.71-3.71,9.725,0,13.435l34.104,34.104L129.612,162.788z"
            />
        </g>
    </svg>
</template>
<script>
export default {
    name: "RoundRobin",
};
</script>
